module.exports = __webpack_public_path__ + "static/img/video-post.f0a711d9.jpg";